{
  "name": "stb-staffing-ui",
  "version": "2.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration local",
    "start:local": "ng serve --configuration local",
    "start:local-trusted": "ng serve --configuration local-trusted",
    "start:dev": "ng serve --configuration development",
    "start:dev-trusted": "ng serve --configuration development-trusted",
    "start:prod": "ng serve --configuration production",
    "build": "ng build --configuration local",
    "build:local": "ng build --configuration local",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "build:dev-lwa": "ng build --configuration dev-lwa",
    "build:qas-lwa": "ng build --configuration qas-lwa",
    "build:prod-lwa": "ng build --configuration prod-lwa",
    "watch": "ng build --watch --configuration local",
    "test": "ng test"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.8",
    "@angular/cdk": "^21.2.6",
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/material": "^21.2.6",
    "@angular/platform-browser": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@azure/msal-angular": "^6.1.0",
    "@azure/msal-browser": "^5.19.0",
    "@fullcalendar/adaptive": "^6.1.21",
    "@fullcalendar/angular": "^6.1.21",
    "@fullcalendar/core": "^6.1.21",
    "@fullcalendar/daygrid": "^6.1.21",
    "@fullcalendar/list": "^6.1.21",
    "@fullcalendar/timegrid": "^6.1.21",
    "@microsoft/signalr": "^10.0.0",
    "chart.js": "^4.5.1",
    "date-fns": "^2.30.0",
    "ng2-charts": "^10.0.0",
    "ngx-markdown": "^21.2.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
